import { useIsWorkspaceLoading } from "src/contexts/global/WorkspaceContext";

import { useDesignOptionsEnabled } from "./designOptionsEnabled";
import { useDesignOptionId } from "./useDesignOptionId";

/** Active overlay option id for writes/queries; undefined on trunk or when flags are off. */
export const useOverlayOptionId = (): string | undefined => {
  const enabled = useDesignOptionsEnabled();
  const flagsLoading = useIsWorkspaceLoading();
  const { optionId } = useDesignOptionId();
  if (!optionId) {
    return undefined;
  }
  if (flagsLoading) {
    return optionId;
  }
  return enabled ? optionId : undefined;
};
